import ImgOne from '../assets/icon-1.svg';
import ImgTwo from '../assets/icon-2.svg';
import ImgThree from '../assets/icon-3.svg';
import ImgFour from '../assets/icon-4.svg';
import ImgFive from '../assets/icon-5.svg';
import ImgSix from '../assets/icon-6.svg';
// ProcessData
import process1 from '../assets/process-1.png';
import process2 from '../assets/process-2.png';
import process3 from '../assets/process-2.png';
// ClientsData
import Client1 from '../assets/pic-1.png';
import Client2 from '../assets/pic-2.png';
import Client3 from '../assets/pic-3.png';
// Footer Icons
import {
  faPhone,
  faLocation,
  faClock,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
// NavLink Data
export const navLinksData = [
  {
    id: 1,
    name: 'Home',
    path: '/',
  },
  {
    id: 2,
    name: 'Our Mission',
    path: '/#mission',
  },
  {
    id: 3,
    name: 'About',
    path: '/#about',
  },

  {
    id: 4,
    name: 'Team',
    path: '/#team',
  },
  {
    id: 5,
    name: 'Services',
    path: '/#service',
  },
  {
    id: 6,
    name: 'Reviews',
    path: '/#review',
  },

  {
    id: 7,
    name: 'Video Gallery',
    path: 'video-gallery',
  },
  {
    id: 8,
    name: 'Contact',
    path: 'contact',
  },
];

// ServicesData
export const servicesData = [
  {
    img: ImgOne,
    title: 'Alignment Specialist',
    desc: 'With a focus on both aesthetics and functionality, we provide tailored solutions for your unique alignment needs. Trust our expertise to help you achieve a confident and healthy smile.',
  },
  {
    img: ImgTwo,
    title: 'Cosmetic Dentistry',
    desc: 'Our experts specialize in enhancing your teeths appearance, boosting your confidence with a range of treatments, from teeth whitening to veneers. Experience the joy of a radiant smile.',
  },
  {
    img: ImgThree,
    title: 'Oral Hygiene Experts',
    desc: 'Your partners in maintaining a healthy smile. Our dedicated team provides tailored guidance and advanced techniques to ensure optimal oral health. Trust us for personalized care.',
  },
  {
    img: ImgFour,
    title: 'Root Canal Specialist',
    desc: 'Our experienced team excels in root canal therapy, rescuing teeth from discomfort and decay. Rely on our expertise for a pain-free and lasting solution.',
  },
  {
    img: ImgFive,
    title: 'Live Dental Advisory',
    desc: 'Get immediate support and answers to your dental concerns from our team of experienced root canal specialists. Your oral health is our priority',
  },
  {
    img: ImgSix,
    title: 'Cavity Inspection',
    desc: 'We use advanced technology and meticulous attention to detail to protect your teeth from decay, promoting lasting oral health and a confident smile',
  },
];

// ProcessData
export const processData = [
  {
    img: process1,
    title: 'Cosmetic Dentistry',
    desc: 'Transform your smile with the artistry of Cosmetic Dentistry.',
  },
  {
    img: process2,
    title: 'Pediatric Dentistry',
    desc: 'Specializing in gentle care for your childs smile.',
  },
  {
    img: process3,
    title: 'Dental Implants',
    desc: 'Revitalize your smile with the stability of Dental Implants',
  },
];

// ClientsData
export const clientsData = [
  {
    img: Client1,
    name: 'william',
    desc: 'I could not be happier with my new smile after getting dental implants. The teams precision and care made the procedure a breeze',
    title: 'satisfied client',
  },
  {
    img: Client2,
    name: 'jennifer',
    desc: 'As a parent, I am relieved to have found a pediatric dentist who truly understands my childs needs. They have made each visit enjoyable and stress-free',
    title: 'satisfied client',
  },
  {
    img: Client3,
    name: 'john deo',
    desc: 'The Cosmetic Dentistry services here have transformed my confidence. My smile has never looked better, and I am grateful for their expertise.',
    title: 'satisfied client',
  },
];

//team data
export const TeamData = [
  {
    img: Client1,
    name: 'william',
    desc: 'I could not be happier with my new smile after getting dental implants. The teams precision and care made the procedure a breeze',
    title: 'Pediatric dentistry',
  },
  {
    img: Client2,
    name: 'jennifer',
    desc: 'As a parent, I am relieved to have found a pediatric dentist who truly understands my childs needs. They have made each visit enjoyable and stress-free',
    title: 'Periodontist',
  },
  {
    img: Client3,
    name: 'john deo',
    desc: 'The Cosmetic Dentistry services here have transformed my confidence. My smile has never looked better, and I am grateful for their expertise.',
    title: 'Cosmetic dentistry',
  },
];

// footerData
export const footerData = [
  {
    icon: faPhone,
    title: 'Phone Number',
    Firstsubtitle: '+123-456-7890',
    Secondsubtitle: '+111-222-3333',
  },
  {
    icon: faLocation,
    title: 'Our Address',
    Firstsubtitle: 'Thathal ITS, Phase-7',
  },
  {
    icon: faClock,
    title: 'Opening Hours',
    Firstsubtitle: '9:00am to 9:00pm',
  },
  {
    icon: faEnvelope,
    title: 'Email Address',
    Firstsubtitle: 'thathal@gmail.com',
    Secondsubtitle: 'thathal2@gmail.com',
  },
];
